"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
class NewsFeed extends base_1.default {
    feed(data) {
        return this.get('news-feed/feed', data);
    }
    addComment(data) {
        return this.post('news-feed/comment', data);
    }
    makeVote(data) {
        return this.post('news-feed/vote', data);
    }
    getAllComments(news_id, limit) {
        return this.get('news-feed/comments', { offset: 0, limit: limit, news_id: news_id });
    }
    deleteComment(newsId, commentId) {
        return this.delete(`/news-feed/comment/${newsId}/${commentId}`);
    }
}
exports.default = new NewsFeed();
